import { alpha, darken, lighten, createTheme, ThemeProvider as ThemeProvider$1 } from '@mui/material/styles';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import React, { useRef, useMemo } from 'react';
import { ScopedCssBaseline, CssBaseline } from '@mui/material';
import { CacheProvider, ThemeProvider as ThemeProvider$2 } from '@emotion/react';
import createCache from '@emotion/cache';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$l = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$k = fails$l;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$k(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$j = fails$l;

var functionBindNative = !fails$j(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$2 = functionBindNative;

var call$e = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = NATIVE_BIND$2 ? call$e.bind(call$e) : function () {
  return call$e.apply(call$e, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$d = FunctionPrototype$2.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND$1 && FunctionPrototype$2.bind.bind(call$d, call$d);

var functionUncurryThis = NATIVE_BIND$1 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$d.apply(fn, arguments);
  };
};

var uncurryThis$i = functionUncurryThis;

var toString$a = uncurryThis$i({}.toString);
var stringSlice$7 = uncurryThis$i(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$7(toString$a(it), 8, -1);
};

var uncurryThis$h = functionUncurryThis;
var fails$i = fails$l;
var classof$3 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$h(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$i(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$3(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$8 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (isNullOrUndefined$1(it)) throw new $TypeError$8("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$4 = function (it) {
  return IndexedObject$1(requireObjectCoercible$6(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$g = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$f = isCallable$g;

var isObject$7 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$f(it);
};

var globalThis$j = globalThis_1;
var isCallable$e = isCallable$g;

var aFunction = function (argument) {
  return isCallable$e(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$j[namespace]) : globalThis$j[namespace] && globalThis$j[namespace][method];
};

var uncurryThis$g = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$g({}.isPrototypeOf);

var globalThis$i = globalThis_1;

var navigator = globalThis$i.navigator;
var userAgent$2 = navigator && navigator.userAgent;

var environmentUserAgent = userAgent$2 ? String(userAgent$2) : '';

var globalThis$h = globalThis_1;
var userAgent$1 = environmentUserAgent;

var process$1 = globalThis$h.process;
var Deno = globalThis$h.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$1) {
  match = userAgent$1.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$1.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = environmentV8Version;
var fails$h = fails$l;
var globalThis$g = globalThis_1;

var $String$5 = globalThis$g.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$h(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$3;
var isCallable$d = isCallable$g;
var isPrototypeOf$2 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$d($Symbol) && isPrototypeOf$2($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$c = isCallable$g;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$2 = function (argument) {
  if (isCallable$c(argument)) return argument;
  throw new $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable$1 = aCallable$2;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$4 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$1(func);
};

var call$c = functionCall;
var isCallable$b = isCallable$g;
var isObject$6 = isObject$7;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$b(fn = input.toString) && !isObject$6(val = call$c(fn, input))) return val;
  if (isCallable$b(fn = input.valueOf) && !isObject$6(val = call$c(fn, input))) return val;
  if (pref !== 'string' && isCallable$b(fn = input.toString) && !isObject$6(val = call$c(fn, input))) return val;
  throw new $TypeError$6("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var globalThis$f = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$3 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$3(globalThis$f, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$f[key] = value;
  } return value;
};

var globalThis$e = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$e[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.45.1',
  mode: 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.45.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$5 = requireObjectCoercible$7;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return $Object$2(requireObjectCoercible$5(argument));
};

var uncurryThis$f = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$f({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$e = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$9 = uncurryThis$e(1.1.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$9(++id + postfix, 36);
};

var globalThis$d = globalThis_1;
var shared$3 = shared$4;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = globalThis$d.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$8 = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$9(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$b = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$3 = getMethod$4;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$7 = wellKnownSymbol$8;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$7('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$3(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$b(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw new $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var globalThis$c = globalThis_1;
var isObject$4 = isObject$7;

var document$1 = globalThis$c.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$g = fails$l;
var createElement = documentCreateElement$1;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$g(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$9 = descriptors;
var call$a = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$2(!call$a(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$8 = descriptors;
var fails$f = fails$l;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$f(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$3 = isObject$7;

var $String$3 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$c = function (argument) {
  if (isObject$3(argument)) return argument;
  throw new $TypeError$4($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$b = anObject$c;
var toPropertyKey = toPropertyKey$2;

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey(P);
  anObject$b(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey(P);
  anObject$b(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$3('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$4 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$5 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$d = functionUncurryThis;
var isCallable$a = isCallable$g;
var store$1 = sharedStoreExports;

var functionToString = uncurryThis$d(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$a(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var globalThis$b = globalThis_1;
var isCallable$9 = isCallable$g;

var WeakMap$1 = globalThis$b.WeakMap;

var weakMapBasicDetection = isCallable$9(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$a = globalThis_1;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$6 = hasOwnProperty_1;
var shared$1 = sharedStoreExports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis$a.TypeError;
var WeakMap = globalThis$a.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has$1 = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$c = functionUncurryThis;
var fails$e = fails$l;
var isCallable$8 = isCallable$g;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$4 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$1 = InternalStateModule$1.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;
var stringSlice$6 = uncurryThis$c(''.slice);
var replace$3 = uncurryThis$c(''.replace);
var join = uncurryThis$c([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$4 && !fails$e(function () {
  return defineProperty$2(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$6($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$3($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS$4) defineProperty$2(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$2(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$4) defineProperty$2(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$8(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var makeBuiltInExports = makeBuiltIn$3.exports;

var isCallable$7 = isCallable$g;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$5 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$7(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil$1 = Math.ceil;
var floor$2 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2 : ceil$1)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$6 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$5 = toIntegerOrInfinity$6;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$5(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$6;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  var len = toIntegerOrInfinity$4(argument);
  return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$b = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$b([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$3;
var uncurryThis$a = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$a = anObject$c;

var concat$2 = uncurryThis$a([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$a(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$d = fails$l;
var isCallable$6 = isCallable$g;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$6(detection) ? fails$d(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var globalThis$9 = globalThis_1;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$4 = defineBuiltIn$5;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$9;
  } else if (STATIC) {
    target = globalThis$9[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$9[TARGET] && globalThis$9[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$4(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var uncurryThis$9 = functionUncurryThis;
var call$9 = functionCall;
var fails$c = fails$l;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$4;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;
var concat$1 = uncurryThis$9([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$c(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || call$9(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$7 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$7({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

const defaultKalturaBreakpoint = {
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1600
};
const breakpoints = kalturaBreakpoints => ({
  keys: ["xs", "sm", "md", "lg", "xl"],
  values: {
    xs: 0,
    sm: kalturaBreakpoints.sm,
    md: kalturaBreakpoints.md,
    lg: kalturaBreakpoints.lg,
    xl: kalturaBreakpoints.xl
  }
});

const defaultKalturaLightTones = {
  tone1: '#333333',
  tone2: '#707070',
  tone3: '#878787',
  tone4: '#BDBDBD',
  tone5: '#D9D9D9',
  tone6: '#EBEBEB',
  tone7: '#F5F5F5',
  tone8: '#FFFFFF',
  danger: {
    main: '#CA1C2D',
    light: '#E33547',
    dark: '#9D1523',
    contrastText: '#FFFFFF'
  },
  success: {
    main: '#23803A',
    light: '#33BC55',
    dark: '#13441F',
    contrastText: '#FFFFFF'
  },
  warning: {
    main: '#C2570A',
    light: '#F26C0D',
    dark: '#914108',
    contrastText: '#FFFFFF'
  },
  info: {
    main: '#006EFA',
    light: '#4798FF',
    dark: '#004CAD',
    contrastText: '#FFFFFF'
  },
  surfaces: {
    background: '#FFFFFF',
    paper: '#F5F5F5',
    elevated: '#FFFFFF',
    protection: '#3D3D3D' // TODO seems to be added by mistake - condsider to remove
  },
  backdrop: {
    color: '#222222',
    opacity: 0.6
  }
};

const defaultFontFamily$1 = "Lato, Helvetica Neue, Segoe UI, sans-serif";
const generateKalturaTypography = overrides => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
  const fontFamily = (overrides === null || overrides === void 0 ? void 0 : overrides.fontFamily) ? overrides.fontFamily : defaultFontFamily$1;
  return {
    fontFamily: fontFamily,
    webFontUrl: '',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    lineHeight: 'auto',
    color: defaultKalturaLightTones.tone1,
    heading1: {
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.2,
      letterSpacing: "normal",
      fontFamily: ((_a = overrides === null || overrides === void 0 ? void 0 : overrides.heading1) === null || _a === void 0 ? void 0 : _a.fontFamily) ? (_b = overrides === null || overrides === void 0 ? void 0 : overrides.heading1) === null || _b === void 0 ? void 0 : _b.fontFamily : fontFamily,
      topBottomMargins: '2rem'
    },
    heading2: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.2,
      letterSpacing: "normal",
      fontFamily: ((_c = overrides === null || overrides === void 0 ? void 0 : overrides.heading2) === null || _c === void 0 ? void 0 : _c.fontFamily) ? (_d = overrides === null || overrides === void 0 ? void 0 : overrides.heading2) === null || _d === void 0 ? void 0 : _d.fontFamily : fontFamily,
      topBottomMargins: '1rem'
    },
    heading3: {
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.2,
      letterSpacing: "normal",
      fontFamily: ((_e = overrides === null || overrides === void 0 ? void 0 : overrides.heading3) === null || _e === void 0 ? void 0 : _e.fontFamily) ? (_f = overrides === null || overrides === void 0 ? void 0 : overrides.heading3) === null || _f === void 0 ? void 0 : _f.fontFamily : fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading4: {
      fontWeight: 700,
      fontSize: "1.25rem",
      lineHeight: 1.2,
      letterSpacing: "normal",
      fontFamily: ((_g = overrides === null || overrides === void 0 ? void 0 : overrides.heading4) === null || _g === void 0 ? void 0 : _g.fontFamily) ? (_h = overrides === null || overrides === void 0 ? void 0 : overrides.heading4) === null || _h === void 0 ? void 0 : _h.fontFamily : fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading5: {
      fontWeight: 700,
      fontSize: "1.15rem",
      lineHeight: 1.2,
      letterSpacing: "normal",
      fontFamily: ((_j = overrides === null || overrides === void 0 ? void 0 : overrides.heading5) === null || _j === void 0 ? void 0 : _j.fontFamily) ? (_k = overrides === null || overrides === void 0 ? void 0 : overrides.heading5) === null || _k === void 0 ? void 0 : _k.fontFamily : fontFamily,
      topBottomMargins: '0.25rem'
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.3,
      letterSpacing: "normal",
      fontFamily: ((_l = overrides === null || overrides === void 0 ? void 0 : overrides.body1) === null || _l === void 0 ? void 0 : _l.fontFamily) ? (_m = overrides === null || overrides === void 0 ? void 0 : overrides.body1) === null || _m === void 0 ? void 0 : _m.fontFamily : fontFamily
    },
    body1Highlight: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: 1.3,
      letterSpacing: "normal",
      fontFamily: ((_o = overrides === null || overrides === void 0 ? void 0 : overrides.body1Highlight) === null || _o === void 0 ? void 0 : _o.fontFamily) ? (_p = overrides === null || overrides === void 0 ? void 0 : overrides.body1Highlight) === null || _p === void 0 ? void 0 : _p.fontFamily : fontFamily
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.3,
      letterSpacing: "normal",
      fontFamily: ((_q = overrides === null || overrides === void 0 ? void 0 : overrides.body2) === null || _q === void 0 ? void 0 : _q.fontFamily) ? (_r = overrides === null || overrides === void 0 ? void 0 : overrides.body2) === null || _r === void 0 ? void 0 : _r.fontFamily : fontFamily
    },
    body2Highlight: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: 1.3,
      letterSpacing: "normal",
      fontFamily: ((_s = overrides === null || overrides === void 0 ? void 0 : overrides.body2Highlight) === null || _s === void 0 ? void 0 : _s.fontFamily) ? (_t = overrides === null || overrides === void 0 ? void 0 : overrides.body2Highlight) === null || _t === void 0 ? void 0 : _t.fontFamily : fontFamily
    },
    buttonLabel1: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: ((_u = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel1) === null || _u === void 0 ? void 0 : _u.fontFamily) ? (_v = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel1) === null || _v === void 0 ? void 0 : _v.fontFamily : fontFamily,
      textTransform: (_w = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel1) === null || _w === void 0 ? void 0 : _w.textTransform
    },
    buttonLabel2: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: ((_x = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel2) === null || _x === void 0 ? void 0 : _x.fontFamily) ? (_y = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel2) === null || _y === void 0 ? void 0 : _y.fontFamily : fontFamily,
      textTransform: (_z = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel2) === null || _z === void 0 ? void 0 : _z.textTransform
    },
    formLabel: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "16px",
      letterSpacing: "normal",
      fontFamily: ((_0 = overrides === null || overrides === void 0 ? void 0 : overrides.formLabel) === null || _0 === void 0 ? void 0 : _0.fontFamily) ? (_1 = overrides === null || overrides === void 0 ? void 0 : overrides.formLabel) === null || _1 === void 0 ? void 0 : _1.fontFamily : fontFamily,
      textTransform: (_2 = overrides === null || overrides === void 0 ? void 0 : overrides.formLabel) === null || _2 === void 0 ? void 0 : _2.textTransform
    },
    formError: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: "18px",
      letterSpacing: "normal",
      fontFamily: ((_3 = overrides === null || overrides === void 0 ? void 0 : overrides.formError) === null || _3 === void 0 ? void 0 : _3.fontFamily) ? (_4 = overrides === null || overrides === void 0 ? void 0 : overrides.formError) === null || _4 === void 0 ? void 0 : _4.fontFamily : fontFamily,
      textTransform: (_5 = overrides === null || overrides === void 0 ? void 0 : overrides.formError) === null || _5 === void 0 ? void 0 : _5.textTransform
    }
  };
};
const typography = kalturaTheme => ({
  htmlFontSize: 16,
  fontFamily: kalturaTheme.typography.fontFamily,
  fontSize: kalturaTheme.typography.fontSize,
  fontWeightLight: kalturaTheme.typography.fontWeightLight,
  fontWeightRegular: kalturaTheme.typography.fontWeightRegular,
  fontWeightMedium: kalturaTheme.typography.fontWeightMedium,
  fontWeightBold: kalturaTheme.typography.fontWeightBold,
  h1: Object.assign(Object.assign({}, kalturaTheme.typography.heading1), {
    marginTop: kalturaTheme.typography.heading1.topBottomMargins,
    marginBottom: kalturaTheme.typography.heading1.topBottomMargins
  }),
  h2: Object.assign(Object.assign({}, kalturaTheme.typography.heading2), {
    marginTop: kalturaTheme.typography.heading2.topBottomMargins,
    marginBottom: kalturaTheme.typography.heading2.topBottomMargins
  }),
  h3: Object.assign(Object.assign({}, kalturaTheme.typography.heading3), {
    marginTop: kalturaTheme.typography.heading3.topBottomMargins,
    marginBottom: kalturaTheme.typography.heading3.topBottomMargins
  }),
  h4: Object.assign(Object.assign({}, kalturaTheme.typography.heading4), {
    marginTop: kalturaTheme.typography.heading4.topBottomMargins,
    marginBottom: kalturaTheme.typography.heading4.topBottomMargins
  }),
  h5: Object.assign(Object.assign({}, kalturaTheme.typography.heading5), {
    marginTop: kalturaTheme.typography.heading5.topBottomMargins,
    marginBottom: kalturaTheme.typography.heading5.topBottomMargins
  }),
  body1: Object.assign({}, kalturaTheme.typography.body1),
  body1Highlight: Object.assign({}, kalturaTheme.typography.body1Highlight),
  body2: Object.assign({}, kalturaTheme.typography.body2),
  body2Highlight: Object.assign({}, kalturaTheme.typography.body2Highlight),
  button: Object.assign(Object.assign({}, kalturaTheme.typography.buttonLabel1), {
    textTransform: kalturaTheme.typography.buttonLabel1.textTransform
  }),
  buttonLabel1: Object.assign(Object.assign({}, kalturaTheme.typography.buttonLabel1), {
    textTransform: kalturaTheme.typography.buttonLabel1.textTransform
  }),
  buttonLabel2: Object.assign(Object.assign({}, kalturaTheme.typography.buttonLabel2), {
    textTransform: kalturaTheme.typography.buttonLabel2.textTransform
  }),
  formLabel: Object.assign(Object.assign({}, kalturaTheme.typography.formLabel), {
    textTransform: kalturaTheme.typography.formLabel.textTransform
  }),
  formError: Object.assign(Object.assign({}, kalturaTheme.typography.formError), {
    textTransform: kalturaTheme.typography.formError.textTransform
  })
});

const defaultKalturaDarkTones = {
  tone1: '#FFFFFF',
  tone2: '#CCCCCC',
  tone3: '#999999',
  tone4: '#666666',
  tone5: '#525252',
  tone6: '#383838',
  tone7: '#212121',
  tone8: '#000000',
  danger: {
    main: '#E95E6C',
    light: '#F2A1A9',
    dark: '#DB1E32',
    contrastText: '#000000'
  },
  success: {
    main: '#31B551',
    light: '#4ACE6B',
    dark: '#268C3F',
    contrastText: '#000000'
  },
  warning: {
    main: '#F26C0D',
    light: '#F58A3D',
    dark: '#C2570A',
    contrastText: '#000000'
  },
  info: {
    main: '#006EFA',
    light: '#4798FF',
    dark: '#004CAD',
    contrastText: '#FFFFFF'
  },
  surfaces: {
    background: '#121212',
    paper: '#242424',
    elevated: '#333333',
    protection: '#3D3D3D' // TODO seems to be added by mistake - condsider to remove
  },
  backdrop: {
    color: '#222222',
    opacity: 0.6
  }
};

var getContrast = {};

/*
color
*/

var colors = {
    maroon      : "#800000",
    red         : "#ff0000",
    orange      : "#ffA500",
    yellow      : "#ffff00",
    olive       : "#808000",
    purple      : "#800080",
    fuchsia     : "#ff00ff",
    white       : "#ffffff",
    lime        : "#00ff00",
    green       : "#008000",
    navy        : "#000080",
    blue        : "#0000ff",
    aqua        : "#00ffff",
    teal        : "#008080",
    black       : "#000000",
    silver      : "#c0c0c0",
    gray        : "#808080",
    transparent : "#0000"
};

var RGBtoRGB = function(r, g, b, a){
    if (a == null || a === "") a = 1;
    r = parseFloat(r);
    g = parseFloat(g);
    b = parseFloat(b);
    a = parseFloat(a);
    if (!(r <= 255 && r >= 0 && g <= 255 && g >= 0 && b <= 255 && b >= 0 && a <= 1 && a >= 0)) return null

    return [Math.round(r), Math.round(g), Math.round(b), a]
};

var HEXtoRGB = function(hex){
    if (hex.length === 3) hex += "f";
    if (hex.length === 4){
        var h0 = hex.charAt(0),
            h1 = hex.charAt(1),
            h2 = hex.charAt(2),
            h3 = hex.charAt(3);

        hex = h0 + h0 + h1 + h1 + h2 + h2 + h3 + h3;
    }
    if (hex.length === 6) hex += "ff";
    var rgb = [];
    for (var i = 0, l = hex.length; i < l; i += 2) rgb.push(parseInt(hex.substr(i, 2), 16) / (i === 6 ? 255 : 1));
    return rgb
};

// HSL to RGB conversion from:
// http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
// thank you!

var HUEtoRGB = function(p, q, t){
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t
    if (t < 1 / 2) return q
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
    return p
};

var HSLtoRGB = function(h, s, l, a){
    var r, b, g;
    if (a == null || a === "") a = 1;
    h = parseFloat(h) / 360;
    s = parseFloat(s) / 100;
    l = parseFloat(l) / 100;
    a = parseFloat(a) / 1;
    if (h > 1 || h < 0 || s > 1 || s < 0 || l > 1 || l < 0 || a > 1 || a < 0) return null
    if (s === 0){
        r = b = g = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = HUEtoRGB(p, q, h + 1 / 3);
        g = HUEtoRGB(p, q, h);
        b = HUEtoRGB(p, q, h - 1 / 3);
    }
    return [r * 255, g * 255, b * 255, a]
};

var keys = [];
for (var c$1 in colors) keys.push(c$1);

var shex  = "(?:#([a-f0-9]{3,8}))",
    sval  = "\\s*([.\\d%]+)\\s*",
    sop   = "(?:,\\s*([.\\d]+)\\s*)?",
    slist = "\\(" + [sval, sval, sval] + sop + "\\)",
    srgb  = "(?:rgb)a?",
    shsl  = "(?:hsl)a?",
    skeys = "(" + keys.join("|") + ")";


var xhex   = RegExp(shex, "i"),
    xrgb   = RegExp(srgb + slist, "i"),
    xhsl   = RegExp(shsl + slist, "i");

var color = function(input, array){
    if (input == null) return null
    input = (input + "").replace(/\s+/, "");

    var match = colors[input];
    if (match){
        return color(match, array)
    } else if (match = input.match(xhex)){
        input = HEXtoRGB(match[1]);
    } else if (match = input.match(xrgb)){
        input = match.slice(1);
    } else if (match = input.match(xhsl)){
        input = HSLtoRGB.apply(null, match.slice(1));
    } else return null

    if (!(input && (input = RGBtoRGB.apply(null, input)))) return null
    if (array) return input
    if (input[3] === 1) input.splice(3, 1);
    return "rgb" + (input.length === 4 ? "a" : "") + "(" + input + ")"
};

var regexp = RegExp([skeys, shex, srgb + slist, shsl + slist].join("|"), "gi");

color.replace = function(string, method){
    if (!method) method = function(match){
        return color(match)
    };
    return (string + "").replace(regexp, method)
};

color.matches = function(string){
    return !!(string + "").match(regexp)
};

var rgb$1 = color;

var n=.2126,r=.7152,t=.0722,e=1/12.92;function u(n){return Math.pow((n+.055)/1.055,2.4)}function a(a){var i=a[0]/255,c=a[1]/255,o=a[2]/255,s=i<=.03928?i*e:u(i),f=c<=.03928?c*e:u(c),l=o<=.03928?o*e:u(o);return s*n+f*r+l*t}function i(n){var r=255;8===(n=n.replace(/^#/,"")).length&&(r=parseInt(n.slice(6,8),16),n=n.substring(0,6)),4===n.length&&(r=parseInt(n.slice(3,4).repeat(2),16),n=n.substring(0,3)),3===n.length&&(n=n[0]+n[0]+n[1]+n[1]+n[2]+n[2]);var t=parseInt(n,16);return [t>>16,t>>8&255,255&t,r]}function c(n,r){return (Math.max(n,r)+.05)/(Math.min(n,r)+.05)}function o(n,r){return c(a(n),a(r))}function s(n,r){return o(i(n),i(r))}function f(n){return n>=7?"AAA":n>=4.5?"AA":n>=3?"AA Large":"Fail"}

var index_m = /*#__PURE__*/Object.freeze({
	__proto__: null,
	hex: s,
	luminance: c,
	rgb: o,
	score: f
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(index_m);

/**
 * Has own property.
 *
 * @type {Function}
 */

var has = Object.prototype.hasOwnProperty;

/**
 * To string.
 *
 * @type {Function}
 */

var toString$8 = Object.prototype.toString;

/**
 * Test whether a value is "empty".
 *
 * @param {Mixed} val
 * @return {Boolean}
 */

function isEmpty$1(val) {
  // Null and Undefined...
  if (val == null) return true

  // Booleans...
  if ('boolean' == typeof val) return false

  // Numbers...
  if ('number' == typeof val) return val === 0

  // Strings...
  if ('string' == typeof val) return val.length === 0

  // Functions...
  if ('function' == typeof val) return val.length === 0

  // Arrays...
  if (Array.isArray(val)) return val.length === 0

  // Errors...
  if (val instanceof Error) return val.message === ''

  // Objects...
  if (val.toString == toString$8) {
    switch (val.toString()) {

      // Maps, Sets, Files and Errors...
      case '[object File]':
      case '[object Map]':
      case '[object Set]': {
        return val.size === 0
      }

      // Plain objects...
      case '[object Object]': {
        for (var key in val) {
          if (has.call(val, key)) return false
        }

        return true
      }
    }
  }

  // Anything else...
  return false
}

/**
 * Export `isEmpty`.
 *
 * @type {Function}
 */

var lib = isEmpty$1;

/*!
 * is-whitespace <https://github.com/jonschlinkert/is-whitespace>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

var cache;

var isWhitespace$1 = function isWhitespace(str) {
  return (typeof str === 'string') && regex().test(str);
};

function regex() {
  // ensure that runtime compilation only happens once
  return cache || (cache = new RegExp('^[\\s\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF"]+$'));
}

var isEmpty = lib;
var isWhitespace = isWhitespace$1;

function isString (object) {
  return typeof object === 'string'
}

var isBlank$1 = function (object) {
  return isString(object) && object.length ? isWhitespace(object) : isEmpty(object)
};

var aqua$1 = "#00ffff";
var aliceblue$1 = "#f0f8ff";
var antiquewhite$1 = "#faebd7";
var black$1 = "#000000";
var blue$1 = "#0000ff";
var cyan$1 = "#00ffff";
var darkblue$1 = "#00008b";
var darkcyan$1 = "#008b8b";
var darkgreen$1 = "#006400";
var darkturquoise$1 = "#00ced1";
var deepskyblue$1 = "#00bfff";
var green$1 = "#008000";
var lime$1 = "#00ff00";
var mediumblue$1 = "#0000cd";
var mediumspringgreen$1 = "#00fa9a";
var navy$1 = "#000080";
var springgreen$1 = "#00ff7f";
var teal$1 = "#008080";
var midnightblue$1 = "#191970";
var dodgerblue$1 = "#1e90ff";
var lightseagreen$1 = "#20b2aa";
var forestgreen$1 = "#228b22";
var seagreen$1 = "#2e8b57";
var darkslategray$1 = "#2f4f4f";
var darkslategrey$1 = "#2f4f4f";
var limegreen$1 = "#32cd32";
var mediumseagreen$1 = "#3cb371";
var turquoise$1 = "#40e0d0";
var royalblue$1 = "#4169e1";
var steelblue$1 = "#4682b4";
var darkslateblue$1 = "#483d8b";
var mediumturquoise$1 = "#48d1cc";
var indigo$1 = "#4b0082";
var darkolivegreen$1 = "#556b2f";
var cadetblue$1 = "#5f9ea0";
var cornflowerblue$1 = "#6495ed";
var mediumaquamarine$1 = "#66cdaa";
var dimgray$1 = "#696969";
var dimgrey$1 = "#696969";
var slateblue$1 = "#6a5acd";
var olivedrab$1 = "#6b8e23";
var slategray$1 = "#708090";
var slategrey$1 = "#708090";
var lightslategray$1 = "#778899";
var lightslategrey$1 = "#778899";
var mediumslateblue$1 = "#7b68ee";
var lawngreen$1 = "#7cfc00";
var aquamarine$1 = "#7fffd4";
var chartreuse$1 = "#7fff00";
var gray$1 = "#808080";
var grey$1 = "#808080";
var maroon$1 = "#800000";
var olive$1 = "#808000";
var purple$1 = "#800080";
var lightskyblue$1 = "#87cefa";
var skyblue$1 = "#87ceeb";
var blueviolet$1 = "#8a2be2";
var darkmagenta$1 = "#8b008b";
var darkred$1 = "#8b0000";
var saddlebrown$1 = "#8b4513";
var darkseagreen$1 = "#8fbc8f";
var lightgreen$1 = "#90ee90";
var mediumpurple$1 = "#9370db";
var darkviolet$1 = "#9400d3";
var palegreen$1 = "#98fb98";
var darkorchid$1 = "#9932cc";
var yellowgreen$1 = "#9acd32";
var sienna$1 = "#a0522d";
var brown$1 = "#a52a2a";
var darkgray$1 = "#a9a9a9";
var darkgrey$1 = "#a9a9a9";
var greenyellow$1 = "#adff2f";
var lightblue$1 = "#add8e6";
var paleturquoise$1 = "#afeeee";
var lightsteelblue$1 = "#b0c4de";
var powderblue$1 = "#b0e0e6";
var firebrick$1 = "#b22222";
var darkgoldenrod$1 = "#b8860b";
var mediumorchid$1 = "#ba55d3";
var rosybrown$1 = "#bc8f8f";
var darkkhaki$1 = "#bdb76b";
var silver$1 = "#c0c0c0";
var mediumvioletred$1 = "#c71585";
var indianred$1 = "#cd5c5c";
var peru$1 = "#cd853f";
var chocolate$1 = "#d2691e";
var tan$1 = "#d2b48c";
var lightgray$1 = "#d3d3d3";
var lightgrey$1 = "#d3d3d3";
var thistle$1 = "#d8bfd8";
var goldenrod$1 = "#daa520";
var orchid$1 = "#da70d6";
var palevioletred$1 = "#db7093";
var crimson$1 = "#dc143c";
var gainsboro$1 = "#dcdcdc";
var plum$1 = "#dda0dd";
var burlywood$1 = "#deb887";
var lightcyan$1 = "#e0ffff";
var lavender$1 = "#e6e6fa";
var darksalmon$1 = "#e9967a";
var palegoldenrod$1 = "#eee8aa";
var violet$1 = "#ee82ee";
var azure$1 = "#f0ffff";
var honeydew$1 = "#f0fff0";
var khaki$1 = "#f0e68c";
var lightcoral$1 = "#f08080";
var sandybrown$1 = "#f4a460";
var beige$1 = "#f5f5dc";
var mintcream$1 = "#f5fffa";
var wheat$1 = "#f5deb3";
var whitesmoke$1 = "#f5f5f5";
var ghostwhite$1 = "#f8f8ff";
var lightgoldenrodyellow$1 = "#fafad2";
var linen$1 = "#faf0e6";
var salmon$1 = "#fa8072";
var oldlace$1 = "#fdf5e6";
var bisque$1 = "#ffe4c4";
var blanchedalmond$1 = "#ffebcd";
var coral$1 = "#ff7f50";
var cornsilk$1 = "#fff8dc";
var darkorange$1 = "#ff8c00";
var deeppink$1 = "#ff1493";
var floralwhite$1 = "#fffaf0";
var fuchsia$1 = "#ff00ff";
var gold$1 = "#ffd700";
var hotpink$1 = "#ff69b4";
var ivory$1 = "#fffff0";
var lavenderblush$1 = "#fff0f5";
var lemonchiffon$1 = "#fffacd";
var lightpink$1 = "#ffb6c1";
var lightsalmon$1 = "#ffa07a";
var lightyellow$1 = "#ffffe0";
var magenta$1 = "#ff00ff";
var mistyrose$1 = "#ffe4e1";
var moccasin$1 = "#ffe4b5";
var navajowhite$1 = "#ffdead";
var orange$1 = "#ffa500";
var orangered$1 = "#ff4500";
var papayawhip$1 = "#ffefd5";
var peachpuff$1 = "#ffdab9";
var pink$1 = "#ffc0cb";
var red$1 = "#ff0000";
var seashell$1 = "#fff5ee";
var snow$1 = "#fffafa";
var tomato$1 = "#ff6347";
var white$1 = "#ffffff";
var yellow$1 = "#ffff00";
var rebeccapurple$1 = "#663399";
var require$$0 = {
	aqua: aqua$1,
	aliceblue: aliceblue$1,
	antiquewhite: antiquewhite$1,
	black: black$1,
	blue: blue$1,
	cyan: cyan$1,
	darkblue: darkblue$1,
	darkcyan: darkcyan$1,
	darkgreen: darkgreen$1,
	darkturquoise: darkturquoise$1,
	deepskyblue: deepskyblue$1,
	green: green$1,
	lime: lime$1,
	mediumblue: mediumblue$1,
	mediumspringgreen: mediumspringgreen$1,
	navy: navy$1,
	springgreen: springgreen$1,
	teal: teal$1,
	midnightblue: midnightblue$1,
	dodgerblue: dodgerblue$1,
	lightseagreen: lightseagreen$1,
	forestgreen: forestgreen$1,
	seagreen: seagreen$1,
	darkslategray: darkslategray$1,
	darkslategrey: darkslategrey$1,
	limegreen: limegreen$1,
	mediumseagreen: mediumseagreen$1,
	turquoise: turquoise$1,
	royalblue: royalblue$1,
	steelblue: steelblue$1,
	darkslateblue: darkslateblue$1,
	mediumturquoise: mediumturquoise$1,
	indigo: indigo$1,
	darkolivegreen: darkolivegreen$1,
	cadetblue: cadetblue$1,
	cornflowerblue: cornflowerblue$1,
	mediumaquamarine: mediumaquamarine$1,
	dimgray: dimgray$1,
	dimgrey: dimgrey$1,
	slateblue: slateblue$1,
	olivedrab: olivedrab$1,
	slategray: slategray$1,
	slategrey: slategrey$1,
	lightslategray: lightslategray$1,
	lightslategrey: lightslategrey$1,
	mediumslateblue: mediumslateblue$1,
	lawngreen: lawngreen$1,
	aquamarine: aquamarine$1,
	chartreuse: chartreuse$1,
	gray: gray$1,
	grey: grey$1,
	maroon: maroon$1,
	olive: olive$1,
	purple: purple$1,
	lightskyblue: lightskyblue$1,
	skyblue: skyblue$1,
	blueviolet: blueviolet$1,
	darkmagenta: darkmagenta$1,
	darkred: darkred$1,
	saddlebrown: saddlebrown$1,
	darkseagreen: darkseagreen$1,
	lightgreen: lightgreen$1,
	mediumpurple: mediumpurple$1,
	darkviolet: darkviolet$1,
	palegreen: palegreen$1,
	darkorchid: darkorchid$1,
	yellowgreen: yellowgreen$1,
	sienna: sienna$1,
	brown: brown$1,
	darkgray: darkgray$1,
	darkgrey: darkgrey$1,
	greenyellow: greenyellow$1,
	lightblue: lightblue$1,
	paleturquoise: paleturquoise$1,
	lightsteelblue: lightsteelblue$1,
	powderblue: powderblue$1,
	firebrick: firebrick$1,
	darkgoldenrod: darkgoldenrod$1,
	mediumorchid: mediumorchid$1,
	rosybrown: rosybrown$1,
	darkkhaki: darkkhaki$1,
	silver: silver$1,
	mediumvioletred: mediumvioletred$1,
	indianred: indianred$1,
	peru: peru$1,
	chocolate: chocolate$1,
	tan: tan$1,
	lightgray: lightgray$1,
	lightgrey: lightgrey$1,
	thistle: thistle$1,
	goldenrod: goldenrod$1,
	orchid: orchid$1,
	palevioletred: palevioletred$1,
	crimson: crimson$1,
	gainsboro: gainsboro$1,
	plum: plum$1,
	burlywood: burlywood$1,
	lightcyan: lightcyan$1,
	lavender: lavender$1,
	darksalmon: darksalmon$1,
	palegoldenrod: palegoldenrod$1,
	violet: violet$1,
	azure: azure$1,
	honeydew: honeydew$1,
	khaki: khaki$1,
	lightcoral: lightcoral$1,
	sandybrown: sandybrown$1,
	beige: beige$1,
	mintcream: mintcream$1,
	wheat: wheat$1,
	whitesmoke: whitesmoke$1,
	ghostwhite: ghostwhite$1,
	lightgoldenrodyellow: lightgoldenrodyellow$1,
	linen: linen$1,
	salmon: salmon$1,
	oldlace: oldlace$1,
	bisque: bisque$1,
	blanchedalmond: blanchedalmond$1,
	coral: coral$1,
	cornsilk: cornsilk$1,
	darkorange: darkorange$1,
	deeppink: deeppink$1,
	floralwhite: floralwhite$1,
	fuchsia: fuchsia$1,
	gold: gold$1,
	hotpink: hotpink$1,
	ivory: ivory$1,
	lavenderblush: lavenderblush$1,
	lemonchiffon: lemonchiffon$1,
	lightpink: lightpink$1,
	lightsalmon: lightsalmon$1,
	lightyellow: lightyellow$1,
	magenta: magenta$1,
	mistyrose: mistyrose$1,
	moccasin: moccasin$1,
	navajowhite: navajowhite$1,
	orange: orange$1,
	orangered: orangered$1,
	papayawhip: papayawhip$1,
	peachpuff: peachpuff$1,
	pink: pink$1,
	red: red$1,
	seashell: seashell$1,
	snow: snow$1,
	tomato: tomato$1,
	white: white$1,
	yellow: yellow$1,
	rebeccapurple: rebeccapurple$1
};

var cssColorNames$1 = require$$0;

var cssColorList = function cssColorList() {
  return Object.keys(cssColorNames$1);
};

var cssColors = cssColorList;

var isNamedCssColor$1 = function isNamedCssColor (color) {
  if (typeof color !== 'string') {
    throw new TypeError('is-named-css-color expects a string')
  }

  var cssColorRegex = new RegExp('^' + cssColors().join('|') + '$', 'i');
  return cssColorRegex.test(color)
};

var aliceblue = "#f0f8ff";
var antiquewhite = "#faebd7";
var aqua = "#00ffff";
var aquamarine = "#7fffd4";
var azure = "#f0ffff";
var beige = "#f5f5dc";
var bisque = "#ffe4c4";
var black = "#000000";
var blanchedalmond = "#ffebcd";
var blue = "#0000ff";
var blueviolet = "#8a2be2";
var brown = "#a52a2a";
var burlywood = "#deb887";
var cadetblue = "#5f9ea0";
var chartreuse = "#7fff00";
var chocolate = "#d2691e";
var coral = "#ff7f50";
var cornflowerblue = "#6495ed";
var cornsilk = "#fff8dc";
var crimson = "#dc143c";
var cyan = "#00ffff";
var darkblue = "#00008b";
var darkcyan = "#008b8b";
var darkgoldenrod = "#b8860b";
var darkgray = "#a9a9a9";
var darkgreen = "#006400";
var darkgrey = "#a9a9a9";
var darkkhaki = "#bdb76b";
var darkmagenta = "#8b008b";
var darkolivegreen = "#556b2f";
var darkorange = "#ff8c00";
var darkorchid = "#9932cc";
var darkred = "#8b0000";
var darksalmon = "#e9967a";
var darkseagreen = "#8fbc8f";
var darkslateblue = "#483d8b";
var darkslategray = "#2f4f4f";
var darkslategrey = "#2f4f4f";
var darkturquoise = "#00ced1";
var darkviolet = "#9400d3";
var deeppink = "#ff1493";
var deepskyblue = "#00bfff";
var dimgray = "#696969";
var dimgrey = "#696969";
var dodgerblue = "#1e90ff";
var firebrick = "#b22222";
var floralwhite = "#fffaf0";
var forestgreen = "#228b22";
var fuchsia = "#ff00ff";
var gainsboro = "#dcdcdc";
var ghostwhite = "#f8f8ff";
var goldenrod = "#daa520";
var gold = "#ffd700";
var gray = "#808080";
var green = "#008000";
var greenyellow = "#adff2f";
var grey = "#808080";
var honeydew = "#f0fff0";
var hotpink = "#ff69b4";
var indianred = "#cd5c5c";
var indigo = "#4b0082";
var ivory = "#fffff0";
var khaki = "#f0e68c";
var lavenderblush = "#fff0f5";
var lavender = "#e6e6fa";
var lawngreen = "#7cfc00";
var lemonchiffon = "#fffacd";
var lightblue = "#add8e6";
var lightcoral = "#f08080";
var lightcyan = "#e0ffff";
var lightgoldenrodyellow = "#fafad2";
var lightgray = "#d3d3d3";
var lightgreen = "#90ee90";
var lightgrey = "#d3d3d3";
var lightpink = "#ffb6c1";
var lightsalmon = "#ffa07a";
var lightseagreen = "#20b2aa";
var lightskyblue = "#87cefa";
var lightslategray = "#778899";
var lightslategrey = "#778899";
var lightsteelblue = "#b0c4de";
var lightyellow = "#ffffe0";
var lime = "#00ff00";
var limegreen = "#32cd32";
var linen = "#faf0e6";
var magenta = "#ff00ff";
var maroon = "#800000";
var mediumaquamarine = "#66cdaa";
var mediumblue = "#0000cd";
var mediumorchid = "#ba55d3";
var mediumpurple = "#9370db";
var mediumseagreen = "#3cb371";
var mediumslateblue = "#7b68ee";
var mediumspringgreen = "#00fa9a";
var mediumturquoise = "#48d1cc";
var mediumvioletred = "#c71585";
var midnightblue = "#191970";
var mintcream = "#f5fffa";
var mistyrose = "#ffe4e1";
var moccasin = "#ffe4b5";
var navajowhite = "#ffdead";
var navy = "#000080";
var oldlace = "#fdf5e6";
var olive = "#808000";
var olivedrab = "#6b8e23";
var orange = "#ffa500";
var orangered = "#ff4500";
var orchid = "#da70d6";
var palegoldenrod = "#eee8aa";
var palegreen = "#98fb98";
var paleturquoise = "#afeeee";
var palevioletred = "#db7093";
var papayawhip = "#ffefd5";
var peachpuff = "#ffdab9";
var peru = "#cd853f";
var pink = "#ffc0cb";
var plum = "#dda0dd";
var powderblue = "#b0e0e6";
var purple = "#800080";
var rebeccapurple = "#663399";
var red = "#ff0000";
var rosybrown = "#bc8f8f";
var royalblue = "#4169e1";
var saddlebrown = "#8b4513";
var salmon = "#fa8072";
var sandybrown = "#f4a460";
var seagreen = "#2e8b57";
var seashell = "#fff5ee";
var sienna = "#a0522d";
var silver = "#c0c0c0";
var skyblue = "#87ceeb";
var slateblue = "#6a5acd";
var slategray = "#708090";
var slategrey = "#708090";
var snow = "#fffafa";
var springgreen = "#00ff7f";
var steelblue = "#4682b4";
var tan = "#d2b48c";
var teal = "#008080";
var thistle = "#d8bfd8";
var tomato = "#ff6347";
var turquoise = "#40e0d0";
var violet = "#ee82ee";
var wheat = "#f5deb3";
var white = "#ffffff";
var whitesmoke = "#f5f5f5";
var yellow = "#ffff00";
var yellowgreen = "#9acd32";
var require$$4 = {
	aliceblue: aliceblue,
	antiquewhite: antiquewhite,
	aqua: aqua,
	aquamarine: aquamarine,
	azure: azure,
	beige: beige,
	bisque: bisque,
	black: black,
	blanchedalmond: blanchedalmond,
	blue: blue,
	blueviolet: blueviolet,
	brown: brown,
	burlywood: burlywood,
	cadetblue: cadetblue,
	chartreuse: chartreuse,
	chocolate: chocolate,
	coral: coral,
	cornflowerblue: cornflowerblue,
	cornsilk: cornsilk,
	crimson: crimson,
	cyan: cyan,
	darkblue: darkblue,
	darkcyan: darkcyan,
	darkgoldenrod: darkgoldenrod,
	darkgray: darkgray,
	darkgreen: darkgreen,
	darkgrey: darkgrey,
	darkkhaki: darkkhaki,
	darkmagenta: darkmagenta,
	darkolivegreen: darkolivegreen,
	darkorange: darkorange,
	darkorchid: darkorchid,
	darkred: darkred,
	darksalmon: darksalmon,
	darkseagreen: darkseagreen,
	darkslateblue: darkslateblue,
	darkslategray: darkslategray,
	darkslategrey: darkslategrey,
	darkturquoise: darkturquoise,
	darkviolet: darkviolet,
	deeppink: deeppink,
	deepskyblue: deepskyblue,
	dimgray: dimgray,
	dimgrey: dimgrey,
	dodgerblue: dodgerblue,
	firebrick: firebrick,
	floralwhite: floralwhite,
	forestgreen: forestgreen,
	fuchsia: fuchsia,
	gainsboro: gainsboro,
	ghostwhite: ghostwhite,
	goldenrod: goldenrod,
	gold: gold,
	gray: gray,
	green: green,
	greenyellow: greenyellow,
	grey: grey,
	honeydew: honeydew,
	hotpink: hotpink,
	indianred: indianred,
	indigo: indigo,
	ivory: ivory,
	khaki: khaki,
	lavenderblush: lavenderblush,
	lavender: lavender,
	lawngreen: lawngreen,
	lemonchiffon: lemonchiffon,
	lightblue: lightblue,
	lightcoral: lightcoral,
	lightcyan: lightcyan,
	lightgoldenrodyellow: lightgoldenrodyellow,
	lightgray: lightgray,
	lightgreen: lightgreen,
	lightgrey: lightgrey,
	lightpink: lightpink,
	lightsalmon: lightsalmon,
	lightseagreen: lightseagreen,
	lightskyblue: lightskyblue,
	lightslategray: lightslategray,
	lightslategrey: lightslategrey,
	lightsteelblue: lightsteelblue,
	lightyellow: lightyellow,
	lime: lime,
	limegreen: limegreen,
	linen: linen,
	magenta: magenta,
	maroon: maroon,
	mediumaquamarine: mediumaquamarine,
	mediumblue: mediumblue,
	mediumorchid: mediumorchid,
	mediumpurple: mediumpurple,
	mediumseagreen: mediumseagreen,
	mediumslateblue: mediumslateblue,
	mediumspringgreen: mediumspringgreen,
	mediumturquoise: mediumturquoise,
	mediumvioletred: mediumvioletred,
	midnightblue: midnightblue,
	mintcream: mintcream,
	mistyrose: mistyrose,
	moccasin: moccasin,
	navajowhite: navajowhite,
	navy: navy,
	oldlace: oldlace,
	olive: olive,
	olivedrab: olivedrab,
	orange: orange,
	orangered: orangered,
	orchid: orchid,
	palegoldenrod: palegoldenrod,
	palegreen: palegreen,
	paleturquoise: paleturquoise,
	palevioletred: palevioletred,
	papayawhip: papayawhip,
	peachpuff: peachpuff,
	peru: peru,
	pink: pink,
	plum: plum,
	powderblue: powderblue,
	purple: purple,
	rebeccapurple: rebeccapurple,
	red: red,
	rosybrown: rosybrown,
	royalblue: royalblue,
	saddlebrown: saddlebrown,
	salmon: salmon,
	sandybrown: sandybrown,
	seagreen: seagreen,
	seashell: seashell,
	sienna: sienna,
	silver: silver,
	skyblue: skyblue,
	slateblue: slateblue,
	slategray: slategray,
	slategrey: slategrey,
	snow: snow,
	springgreen: springgreen,
	steelblue: steelblue,
	tan: tan,
	teal: teal,
	thistle: thistle,
	tomato: tomato,
	turquoise: turquoise,
	violet: violet,
	wheat: wheat,
	white: white,
	whitesmoke: whitesmoke,
	yellow: yellow,
	yellowgreen: yellowgreen
};

const rgb = rgb$1;
const wcag = require$$1;
const isBlank = isBlank$1;
const isNamedCssColor = isNamedCssColor$1;
const cssColorNames = require$$4;

getContrast.ratio = ratio;
getContrast.score = score;
getContrast.isAccessible = isAccessible;
getContrast.isNotTransparent = isNotTransparent;

function ratio(colorOne, colorTwo, options) {
  colorOne = getRgbTriplet(colorOne, options);
  colorTwo = getRgbTriplet(colorTwo, options);

  return wcag.rgb(colorOne, colorTwo);
}

function score(colorOne, colorTwo, options) {
  var wcagScore = wcag.score(ratio(colorOne, colorTwo, options));

  if (isBlank(wcagScore)) {
    return "F";
  } else {
    return wcagScore;
  }
}

function isAccessible(colorOne, colorTwo, options) {
  return ratio(colorOne, colorTwo, options) > 4.5;
}

function getRgbTriplet(providedColor, options) {
  if (typeof providedColor !== "string") {
    throw new TypeError("get-contrast expects colors as strings");
  }

  let color = providedColor.toLowerCase();

  if (isNamedCssColor(color)) {
    color = cssColorNames[color];
  }

  color = isNotTransparent(color, options);
  return color
    .match(/\((.*)\)/)[1]
    .split(",")
    .slice(0, 3);
}

function isNotTransparent(color, options) {
  options = options || {};

  // Convert to RGB.
  color = rgb(color);
  // Check if the rgb returned color is rgba and if the 'a' value is 0.
  const cArray = color.match(/\((.*)\)/)[1].split(",");
  if (cArray.length == 4 && cArray[3] == "0" && !options.ignoreAlpha) {
    throw new TypeError("get-contrast cannot contrast transparent colors");
  } else {
    return color;
  }
}

var wellKnownSymbol$6 = wellKnownSymbol$8;

var TO_STRING_TAG$3 = wellKnownSymbol$6('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$5 = isCallable$g;
var classofRaw = classofRaw$1;
var wellKnownSymbol$5 = wellKnownSymbol$8;

var TO_STRING_TAG$2 = wellKnownSymbol$5('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$2 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable$5(O.callee) ? 'Arguments' : result;
};

var classof$1 = classof$2;

var $String$1 = String;

var toString$7 = function (argument) {
  if (classof$1(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$8 = functionUncurryThis;
var requireObjectCoercible$4 = requireObjectCoercible$7;
var toString$6 = toString$7;
var whitespaces$1 = whitespaces$2;

var replace$2 = uncurryThis$8(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$2 = function (TYPE) {
  return function ($this) {
    var string = toString$6(requireObjectCoercible$4($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var globalThis$8 = globalThis_1;
var fails$b = fails$l;
var uncurryThis$7 = functionUncurryThis;
var toString$5 = toString$7;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = globalThis$8.parseInt;
var Symbol$1 = globalThis$8.Symbol;
var ITERATOR$2 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec$1 = uncurryThis$7(hex.exec);
var FORCED$3 = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$2 && !fails$b(function () { $parseInt$1(Object(ITERATOR$2)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$3 ? function parseInt(string, radix) {
  var S = trim(toString$5(string));
  return $parseInt$1(S, (radix >>> 0) || (exec$1(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$6 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$6({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

var uncurryThis$6 = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = uncurryThis$6(1.1.valueOf);

var toIntegerOrInfinity$3 = toIntegerOrInfinity$6;
var toString$4 = toString$7;
var requireObjectCoercible$3 = requireObjectCoercible$7;

var $RangeError$1 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$4(requireObjectCoercible$3(this));
  var result = '';
  var n = toIntegerOrInfinity$3(count);
  if (n < 0 || n === Infinity) throw new $RangeError$1('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$5 = _export;
var uncurryThis$5 = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$6;
var thisNumberValue = thisNumberValue$1;
var $repeat$1 = stringRepeat;
var fails$a = fails$l;

var $RangeError = RangeError;
var $String = String;
var floor$1 = Math.floor;
var repeat$1 = uncurryThis$5($repeat$1);
var stringSlice$5 = uncurryThis$5(''.slice);
var nativeToFixed = uncurryThis$5(1.1.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$1(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$1(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat$1('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$2 = fails$a(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$a(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$5({ target: 'Number', proto: true, forced: FORCED$2 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$2(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat$1('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat$1('0', fractDigits - k) + result
        : stringSlice$5(result, 0, k - fractDigits) + '.' + stringSlice$5(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var uncurryThis$4 = functionUncurryThis;
var toLength$1 = toLength$3;
var toString$3 = toString$7;
var $repeat = stringRepeat;
var requireObjectCoercible$2 = requireObjectCoercible$7;

var repeat = uncurryThis$4($repeat);
var stringSlice$4 = uncurryThis$4(''.slice);
var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod$1 = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString$3(requireObjectCoercible$2($this));
    var intMaxLength = toLength$1(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString$3(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr === '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice$4(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

var stringPad = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod$1(false)};

// https://github.com/zloirock/core-js/issues/280
var userAgent = environmentUserAgent;

var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

var $$4 = _export;
var $padStart = stringPad.start;
var WEBKIT_BUG = stringPadWebkitBug;

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$$4({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var globalThis$7 = globalThis_1;
var fails$9 = fails$l;

// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp$1 = globalThis$7.RegExp;

var FLAGS_GETTER_IS_CORRECT = !fails$9(function () {
  var INDICES_SUPPORT = true;
  try {
    RegExp$1('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {};
  // modern V8 bug
  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, { get: function () {
      calls += chr;
      return true;
    } });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };

  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]);

  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  var result = Object.getOwnPropertyDescriptor(RegExp$1.prototype, 'flags').get.call(O);

  return result !== expected || calls !== expected;
});

var regexpFlagsDetection = { correct: FLAGS_GETTER_IS_CORRECT };

var anObject$9 = anObject$c;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$9(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$8 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf$1 = objectIsPrototypeOf;
var regExpFlagsDetection = regexpFlagsDetection;
var regExpFlagsGetterImplementation = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = regExpFlagsDetection.correct ? function (it) {
  return it.flags;
} : function (it) {
  return (!regExpFlagsDetection.correct && isPrototypeOf$1(RegExpPrototype$2, it) && !hasOwn$2(it, 'flags'))
    ? call$8(regExpFlagsGetterImplementation, it)
    : it.flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$3 = defineBuiltIn$5;
var anObject$8 = anObject$c;
var $toString = toString$7;
var fails$8 = fails$l;
var getRegExpFlags$1 = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$8(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$3(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$8(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags$1(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const hexToHSL = hex => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const normalizedR = r / 255;
  const normalizedG = g / 255;
  const normalizedB = b / 255;
  const cMin = Math.min(normalizedR, normalizedG, normalizedB);
  const cMax = Math.max(normalizedR, normalizedG, normalizedB);
  const delta = cMax - cMin;
  let hue = 0;
  let saturation = 0;
  let lightness = (cMax + cMin) / 2;
  if (delta !== 0) {
    if (cMax === normalizedR) {
      hue = (normalizedG - normalizedB) / delta % 6;
    } else if (cMax === normalizedG) {
      hue = (normalizedB - normalizedR) / delta + 2;
    } else {
      hue = (normalizedR - normalizedG) / delta + 4;
    }
  }
  hue = Math.round(hue * 60);
  if (hue < 0) {
    hue += 360;
  }
  saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));
  saturation = +(saturation * 100).toFixed(1);
  lightness = +(lightness * 100).toFixed(1);
  const hsl = [hue, saturation, lightness];
  return hsl;
};
const HSLToHex = (h, s, l) => {
  s /= 100;
  l /= 100;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(h / 60 % 2 - 1));
  const m = l - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;
  if (h >= 0 && h < 60) {
    r = c;
    g = x;
  } else if (h >= 60 && h < 120) {
    r = x;
    g = c;
  } else if (h >= 120 && h < 180) {
    g = c;
    b = x;
  } else if (h >= 180 && h < 240) {
    g = x;
    b = c;
  } else if (h >= 240 && h < 300) {
    r = x;
    b = c;
  } else if (h >= 300 && h < 360) {
    r = c;
    b = x;
  }
  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);
  const hex = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  return hex;
};
const hexToRGB = h => {
  let r = 0;
  let g = 0;
  let b = 0;
  if (h.length === 4) {
    r = parseInt(h[1] + h[1], 16);
    g = parseInt(h[2] + h[2], 16);
    b = parseInt(h[3] + h[3], 16);
  } else if (h.length === 7) {
    r = parseInt(h.slice(1, 3), 16);
    g = parseInt(h.slice(3, 5), 16);
    b = parseInt(h.slice(5, 7), 16);
  }
  const rgb = [r, g, b];
  return rgb;
};

const CURRENT_EDITOR_VERSION = 1;
var ERoundness;
(function (ERoundness) {
  ERoundness["Sharp"] = "Sharp edges";
  ERoundness["SlightlyRounded"] = "Slightly rounded";
  ERoundness["VeryRounded"] = "Rounded";
})(ERoundness || (ERoundness = {}));
const ERoundnessToNumberMapping = {
  [ERoundness.Sharp]: 0,
  [ERoundness.SlightlyRounded]: 4,
  [ERoundness.VeryRounded]: 8
};
const NumberToERoundnessMapping = {
  0: ERoundness.Sharp,
  4: ERoundness.SlightlyRounded,
  8: ERoundness.VeryRounded
};
var EColorScheme;
(function (EColorScheme) {
  EColorScheme["Neutral"] = "Neutral";
  EColorScheme["Monochrome"] = "Monochrome";
  EColorScheme["Custom"] = "Custom";
})(EColorScheme || (EColorScheme = {}));
const defaultColor = '#006EFA';
const defaultThemeMode = 'dark';
const defaultColorScheme = EColorScheme.Neutral;
const defaultRoundness = ERoundness.SlightlyRounded;
const defaultFontFamily = 'Lato, Helvetica Neue, Segoe UI, sans-serif';
const defaultThemeEditorTokens = {
  meta: {
    version: 2
  },
  brandColor: defaultColor,
  mode: defaultThemeMode,
  colorScheme: defaultColorScheme,
  fontFamily: defaultFontFamily,
  webFontUrl: '',
  roundness: defaultRoundness
};
var EThemeColorType;
(function (EThemeColorType) {
  EThemeColorType["Tone1"] = "Tone1";
  EThemeColorType["Tone2"] = "Tone2";
  EThemeColorType["Tone3"] = "Tone3";
  EThemeColorType["Tone4"] = "Tone4";
  EThemeColorType["Tone5"] = "Tone5";
  EThemeColorType["Tone6"] = "Tone6";
  EThemeColorType["Tone7"] = "Tone7";
  EThemeColorType["Tone8"] = "Tone8";
  EThemeColorType["SurfaceBackground"] = "SurfaceBackground";
  EThemeColorType["SurfacePaper"] = "SurfacePaper";
  EThemeColorType["SurfaceElevated"] = "SurfaceElevated";
})(EThemeColorType || (EThemeColorType = {}));
var EThemeHightContrastColorType;
(function (EThemeHightContrastColorType) {
  EThemeHightContrastColorType["Tone1"] = "Tone1HighContrast";
  EThemeHightContrastColorType["Tone2"] = "Tone2HighContrast";
  EThemeHightContrastColorType["Tone3"] = "Tone3HighContrast";
  EThemeHightContrastColorType["Tone4"] = "Tone4HighContrast";
  EThemeHightContrastColorType["Tone5"] = "Tone5HighContrast";
  EThemeHightContrastColorType["Tone6"] = "Tone6HighContrast";
  EThemeHightContrastColorType["Tone7"] = "Tone7HighContrast";
  EThemeHightContrastColorType["Tone8"] = "Tone8HighContrast";
  EThemeHightContrastColorType["SurfaceBackground"] = "SurfaceBackgroundHighContrast";
  EThemeHightContrastColorType["SurfacePaper"] = "SurfacePaperHighContrast";
  EThemeHightContrastColorType["SurfaceElevated"] = "SurfaceElevatedHighContrast";
})(EThemeHightContrastColorType || (EThemeHightContrastColorType = {}));
var EThemeEditorColorType;
(function (EThemeEditorColorType) {
  EThemeEditorColorType["SchemaOptionTone1"] = "SchemaOptionTone1";
  EThemeEditorColorType["SchemaOptionTone2"] = "SchemaOptionTone2";
  EThemeEditorColorType["SchemaOptionTone3"] = "SchemaOptionTone3";
  EThemeEditorColorType["SchemaOptionTone4"] = "SchemaOptionTone4";
})(EThemeEditorColorType || (EThemeEditorColorType = {}));
//NOTE: these values are constant and come from the designers
const colorTypeLightnessValuesMapping = {
  // regular contrast mapping 
  [EThemeColorType.SurfaceBackground]: [100, 7],
  [EThemeColorType.SurfacePaper]: [96, 14],
  [EThemeColorType.SurfaceElevated]: [100, 20],
  [EThemeColorType.Tone1]: [20, 100],
  [EThemeColorType.Tone2]: [44, 80],
  [EThemeColorType.Tone3]: [53, 60],
  [EThemeColorType.Tone4]: [74, 40],
  [EThemeColorType.Tone5]: [85, 32],
  [EThemeColorType.Tone6]: [92, 22],
  [EThemeColorType.Tone7]: [96, 13],
  [EThemeColorType.Tone8]: [100, 0],
  [EThemeEditorColorType.SchemaOptionTone1]: [20, 92],
  [EThemeEditorColorType.SchemaOptionTone2]: [53, 60],
  [EThemeEditorColorType.SchemaOptionTone3]: [85, 40],
  [EThemeEditorColorType.SchemaOptionTone4]: [92, 26],
  // hight contrast mapping
  [EThemeHightContrastColorType.SurfaceBackground]: [100, 0],
  [EThemeHightContrastColorType.SurfacePaper]: [100, 0],
  [EThemeHightContrastColorType.SurfaceElevated]: [100, 10],
  [EThemeHightContrastColorType.Tone1]: [0, 100],
  [EThemeHightContrastColorType.Tone2]: [0, 100],
  [EThemeHightContrastColorType.Tone3]: [0, 100],
  [EThemeHightContrastColorType.Tone4]: [20, 80],
  [EThemeHightContrastColorType.Tone5]: [92, 24],
  [EThemeHightContrastColorType.Tone6]: [92, 22],
  [EThemeHightContrastColorType.Tone7]: [96, 13],
  [EThemeHightContrastColorType.Tone8]: [100, 0]
};

const getLightnessForMode = (mode, lightValue, darkValue) => {
  return mode === 'light' ? lightValue : mode === 'dark' ? darkValue : 100;
};
const getColorLightnessForMode = (mode, colorType) => {
  const lightnessValues = colorTypeLightnessValuesMapping[colorType];
  return getLightnessForMode(mode, lightnessValues[0], lightnessValues[1]);
};
const getSchemeParameters = (scheme, hue, saturation) => {
  let adjustedSaturation = saturation;
  switch (scheme) {
    case EColorScheme.Neutral:
      adjustedSaturation = 0;
      break;
    case EColorScheme.Monochrome:
      adjustedSaturation = saturation !== 0 ? 24 : 0;
      break;
    case EColorScheme.Custom:
      adjustedSaturation = saturation;
      break;
  }
  return {
    hue,
    saturation: adjustedSaturation
  };
};
const getPrimaryFromTokens = color => {
  const hsl = hexToHSL(color);
  const hue = hsl[0];
  const saturation = hsl[1];
  const lightness = hsl[2];
  //processing primary colors lightness
  const darkLightness = lightness > 10 ? lightness - 10 : 0;
  const lightLightness = lightness < 90 ? lightness + 10 : 100;
  //processing contrast text
  const rgb = hexToRGB(color);
  const luminance = (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
  return {
    dark: HSLToHex(hue, saturation, darkLightness),
    main: HSLToHex(hue, saturation, lightness),
    light: HSLToHex(hue, saturation, lightLightness),
    contrastText: luminance > 0.5 ? '#000000' : '#ffffff'
  };
};
const getColorFromTokens = (tokens, colorType) => {
  //deciding which color to use
  const color = tokens.colorScheme === EColorScheme.Custom ? tokens.otherColor || tokens.brandColor : tokens.brandColor;
  const hsl = hexToHSL(color);
  let hue = hsl[0];
  let saturation = hsl[1];
  const schemeParameters = getSchemeParameters(tokens.colorScheme, hue, saturation);
  hue = schemeParameters.hue;
  saturation = schemeParameters.saturation;
  const lightness = getColorLightnessForMode(tokens.mode, colorType);
  return HSLToHex(hue, saturation, lightness);
};
const getSurfacesProtection = tokens => {
  //deciding which color to use
  const color = tokens.colorScheme === EColorScheme.Custom ? tokens.headerColor || tokens.brandColor : tokens.brandColor;
  const hsl = hexToHSL(color);
  let hue = hsl[0];
  let saturation = hsl[1];
  let lightness = hsl[2];
  const schemeParameters = getSchemeParameters(tokens.colorScheme, hue, saturation);
  hue = schemeParameters.hue;
  saturation = schemeParameters.saturation;
  lightness = tokens.colorScheme === EColorScheme.Custom ? lightness : 24;
  return HSLToHex(hue, saturation, lightness);
};

const TranslucentColors = {
  main: "#fff",
  // TODO seems to be added by mistake - condsider to remove
  dark: "#000",
  // TODO seems to be added by mistake - condsider to remove
  light: "#fff",
  // TODO seems to be added by mistake - condsider to remove
  contrastText: "#fff",
  // TODO seems to be added by mistake - condsider to remove
  commonBlack: '#000000',
  commonWhite: '#FFFFFF'
};
const contrastThreshold = 3;
const generateKalturaPalette = paletteMode => {
  const modeColors = paletteMode === "light" ? defaultKalturaLightTones : defaultKalturaDarkTones;
  return Object.assign({
    primary: {
      light: "#4798FF",
      main: "#006EFA",
      dark: "#004CAD",
      contrastText: "#ffffff"
    },
    secondary: {
      light: "#FFC34C",
      main: "#FFAA00",
      dark: "#B37700",
      contrastText: "#ffffff"
    },
    translucent: TranslucentColors,
    brand: {
      yellow: {
        main: "#FFCD00"
      }
    }
  }, modeColors);
};
const palette = (palette, mode) => ({
  background: {
    paper: palette.surfaces.paper,
    default: palette.surfaces.background
  },
  mode: mode,
  text: {
    primary: palette.tone1,
    secondary: alpha(palette.tone1, 0.7),
    disabled: alpha(palette.tone1, 0.5)
  },
  grey: {
    "100": palette.tone1,
    "200": palette.tone2,
    "300": palette.tone3,
    "400": palette.tone4,
    "500": palette.tone5,
    "600": palette.tone6,
    "700": palette.tone7,
    "800": palette.tone8
  },
  primary: palette.primary,
  secondary: palette.secondary,
  warning: palette.warning,
  success: palette.success,
  info: palette.info,
  divider: "rgba(0, 0, 0, 0.25)",
  tonalOffset: 0.3,
  translucent: {
    main: palette.translucent.commonBlack
  }
});
const augmentColor = color => {
  return {
    light: color.light ? color.light : lighten(color.main, 0.3),
    main: color.main,
    dark: color.dark ? color.dark : darken(color.main, 0.3),
    contrastText: color.contrastText ? color.contrastText : getContrastText(color.main)
  };
};
const getContrastText = background => {
  const ratio = getContrast.ratio(background, defaultKalturaDarkTones.tone1);
  const contrastText = ratio >= contrastThreshold ? defaultKalturaDarkTones.tone1 : defaultKalturaLightTones.tone1;
  if (process.env.NODE_ENV !== "production") {
    const ratioSanity = getContrast.ratio(background, contrastText);
    if (ratioSanity < 3) {
      console.error(`Kaltura-DS: The calculated ratio between text ${contrastText} on ${background} background ` + `is ${getContrast}:1 and is below the WCAG recommended absolute minimum contrast ratio of 3:1.`);
    }
  }
  return contrastText;
};
const augmentPalette = (palette, overridePalette) => {
  return Object.assign(Object.assign({}, palette), {
    primary: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.primary) ? overridePalette.primary : palette.primary),
    secondary: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.secondary) ? overridePalette.secondary : palette.secondary),
    warning: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.warning) ? overridePalette.warning : palette.warning),
    success: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.success) ? overridePalette.success : palette.success)
  });
};
/**
 * apply high-contrast values to a given kaltura pallete
 */
const applyHighContrastKalturaPalette = (paletteMode, palette) => {
  var _a, _b, _c, _d;
  const defaultKalturaPalette = paletteMode === "light" ? defaultKalturaLightTones : defaultKalturaDarkTones;
  const highContrastPallete = Object.assign(Object.assign({}, palette), {
    tone1: getHighContrastColor(palette.tone1, paletteMode, EThemeHightContrastColorType.Tone1) || defaultKalturaPalette.tone1,
    tone2: getHighContrastColor(palette.tone2, paletteMode, EThemeHightContrastColorType.Tone2) || defaultKalturaPalette.tone2,
    tone3: getHighContrastColor(palette.tone3, paletteMode, EThemeHightContrastColorType.Tone3) || defaultKalturaPalette.tone3,
    tone4: getHighContrastColor(palette.tone4, paletteMode, EThemeHightContrastColorType.Tone4) || defaultKalturaPalette.tone4,
    tone5: getHighContrastColor(palette.tone5, paletteMode, EThemeHightContrastColorType.Tone5) || defaultKalturaPalette.tone5,
    tone6: getHighContrastColor(palette.tone6, paletteMode, EThemeHightContrastColorType.Tone6) || defaultKalturaPalette.tone6,
    tone7: getHighContrastColor(palette.tone7, paletteMode, EThemeHightContrastColorType.Tone7) || defaultKalturaPalette.tone7,
    tone8: getHighContrastColor(palette.tone8, paletteMode, EThemeHightContrastColorType.Tone8) || defaultKalturaPalette.tone8,
    surfaces: {
      background: getHighContrastColor((_a = palette.surfaces) === null || _a === void 0 ? void 0 : _a.background, paletteMode, EThemeHightContrastColorType.SurfaceBackground) || defaultKalturaPalette.surfaces.background,
      paper: getHighContrastColor((_b = palette.surfaces) === null || _b === void 0 ? void 0 : _b.paper, paletteMode, EThemeHightContrastColorType.SurfacePaper) || defaultKalturaPalette.surfaces.paper,
      elevated: getHighContrastColor((_c = palette.surfaces) === null || _c === void 0 ? void 0 : _c.elevated, paletteMode, EThemeHightContrastColorType.SurfaceElevated) || defaultKalturaPalette.surfaces.elevated,
      protection: ((_d = palette.surfaces) === null || _d === void 0 ? void 0 : _d.protection) || defaultKalturaPalette.surfaces.protection
    }
  });
  return highContrastPallete;
};
/**
 * apply high-contrast value to a given color
 */
const getHighContrastColor = (color, mode, colorType) => {
  if (!color) {
    return color;
  }
  // get hue and saturation from the given color
  const hsl = hexToHSL(color);
  const hue = hsl[0];
  const saturation = hsl[1];
  // change lightness to high-contrast value (different for each color type)
  const lightness = getColorLightnessForMode(mode, colorType);
  // re-calculate the color with the high-contrast lightness
  return HSLToHex(hue, saturation, lightness);
};

function createMuiTheme(kalturaTheme) {
  const theme = {
    breakpoints: breakpoints(kalturaTheme.breakpoints),
    typography: typography(kalturaTheme),
    palette: palette(kalturaTheme.palette, kalturaTheme.mode),
    transitions: {
      easing: {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
      },
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
      }
    },
    zIndex: {
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500
    },
    spacing: factor => `${0.5 * factor}rem`,
    kaltura: Object.assign({}, kalturaTheme)
  };
  // create the theme.
  return createTheme(Object.assign(Object.assign({}, theme), {
    palette: Object.assign(Object.assign({}, theme.palette), {
      translucent: {
        main: kalturaTheme.palette.translucent.commonBlack
      }
    }),
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true // No more ripple, on the whole application
        }
      },
      MuiScopedCssBaseline: {
        styleOverrides: {
          root: {
            backgroundColor: "unset"
          }
        }
      }
    }
  }));
}

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var deepmerge$1 = /*@__PURE__*/getDefaultExportFromCjs(cjs);

const defaultKalturaElevations = {
  low: "none",
  medium: "0px 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 30px -8px rgba(0, 0, 0, 0.2)",
  high: "0px 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 8px 60px -16px rgba(0, 0, 0, 0.2)"
};

const defaultKalturaShape = {
  roundness1: 4,
  roundness2: 8,
  roundness3: 16
};

const createKalturaTheme = (options = {
  mode: 'light',
  overrides: {}
}) => {
  const {
    mode = 'light',
    overrides = {}
  } = options;
  const palette = deepmerge$1(generateKalturaPalette(mode), deepmerge$1((overrides === null || overrides === void 0 ? void 0 : overrides.palette) || {}, {
    translucent: TranslucentColors
  }));
  return {
    breakpoints: deepmerge$1(defaultKalturaBreakpoint, (overrides === null || overrides === void 0 ? void 0 : overrides.breakpoints) || {}),
    elevations: deepmerge$1(defaultKalturaElevations, (overrides === null || overrides === void 0 ? void 0 : overrides.elevations) || {}),
    palette: augmentPalette(palette, overrides === null || overrides === void 0 ? void 0 : overrides.palette),
    shape: deepmerge$1(defaultKalturaShape, (overrides === null || overrides === void 0 ? void 0 : overrides.shape) || {}),
    typography: deepmerge$1(generateKalturaTypography(overrides === null || overrides === void 0 ? void 0 : overrides.typography), Object.assign({
      color: palette.tone1
    }, overrides === null || overrides === void 0 ? void 0 : overrides.typography)),
    mode: mode
  };
};

const getThemeEditorColorSchemeTones = (mode, colorScheme, color) => {
  const hsl = hexToHSL(color);
  let hue = hsl[0];
  let saturation = hsl[1];
  const schemeParameters = getSchemeParameters(colorScheme, hue, saturation);
  hue = schemeParameters.hue;
  saturation = schemeParameters.saturation;
  const lightnessTone1 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone1);
  const lightnessTone2 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone2);
  const lightnessTone3 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone3);
  const lightnessTone4 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone4);
  const schemeSaturation = colorScheme === EColorScheme.Neutral ? 0 : colorScheme === EColorScheme.Monochrome ? 24 : saturation;
  return {
    tone1: HSLToHex(hue, schemeSaturation, lightnessTone1),
    tone2: HSLToHex(hue, schemeSaturation, lightnessTone2),
    tone3: HSLToHex(hue, schemeSaturation, lightnessTone3),
    tone4: HSLToHex(hue, schemeSaturation, lightnessTone4)
  };
};
const isThemeEditorTokensV1 = obj => {
  var _a, _b, _c;
  return obj && ((_a = obj.meta) === null || _a === void 0 ? void 0 : _a.version) && typeof ((_b = obj.meta) === null || _b === void 0 ? void 0 : _b.version) == 'number' && ((_c = obj.meta) === null || _c === void 0 ? void 0 : _c.version) === 1;
};
const isThemeEditorTokensV2 = obj => {
  var _a, _b, _c;
  return obj && ((_a = obj.meta) === null || _a === void 0 ? void 0 : _a.version) && typeof ((_b = obj.meta) === null || _b === void 0 ? void 0 : _b.version) == 'number' && ((_c = obj.meta) === null || _c === void 0 ? void 0 : _c.version) === 2;
};
const isThemeEditorTokens = obj => {
  var _a, _b;
  return obj && ((_a = obj.meta) === null || _a === void 0 ? void 0 : _a.version) && typeof ((_b = obj.meta) === null || _b === void 0 ? void 0 : _b.version) == 'number';
};
//use this method from outside if needed to load the editor with a certain mode
const getDefaultThemeEditorTokens = mode => {
  return Object.assign(Object.assign({}, defaultThemeEditorTokens), {
    mode: mode,
    meta: {
      version: CURRENT_EDITOR_VERSION
    }
  });
};

var isPrototypeOf = objectIsPrototypeOf;

var $TypeError$2 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$2('Incorrect invocation');
};

var fails$7 = fails$l;

var correctPrototypeGetter = !fails$7(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$1 = hasOwnProperty_1;
var isCallable$4 = isCallable$g;
var toObject$1 = toObject$4;
var sharedKey$1 = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO$1 = sharedKey$1('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var makeBuiltIn = makeBuiltInExports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$1 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$3;

var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$2) definePropertyModule$1.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

var objectDefineProperties = {};

var DESCRIPTORS$1 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$7 = anObject$c;
var toIndexedObject = toIndexedObject$4;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$1 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$7(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$3;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$6 = anObject$c;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$6(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var fails$6 = fails$l;
var isCallable$3 = isCallable$g;
var isObject$1 = isObject$7;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$5;
var wellKnownSymbol$4 = wellKnownSymbol$8;

var ITERATOR$1 = wellKnownSymbol$4('iterator');

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) ;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$2) || fails$6(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$1].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$3(IteratorPrototype$2[ITERATOR$1])) {
  defineBuiltIn$2(IteratorPrototype$2, ITERATOR$1, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2};

var $$3 = _export;
var globalThis$6 = globalThis_1;
var anInstance = anInstance$1;
var anObject$5 = anObject$c;
var isCallable$2 = isCallable$g;
var getPrototypeOf = objectGetPrototypeOf;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var createProperty = createProperty$1;
var fails$5 = fails$l;
var hasOwn = hasOwnProperty_1;
var wellKnownSymbol$3 = wellKnownSymbol$8;
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS = descriptors;

var CONSTRUCTOR = 'constructor';
var ITERATOR = 'Iterator';
var TO_STRING_TAG$1 = wellKnownSymbol$3('toStringTag');

var $TypeError$1 = TypeError;
var NativeIterator = globalThis$6[ITERATOR];

// FF56- have non-standard global helper `Iterator`
var FORCED$1 = !isCallable$2(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype$1
  // FF44- non-standard `Iterator` passes previous tests
  || !fails$5(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype$1);
  if (getPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$1('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS) {
    defineBuiltInAccessor(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$5(this);
        if (this === IteratorPrototype$1) throw new $TypeError$1("You can't redefine this property");
        if (hasOwn(this, key)) this[key] = replacement;
        else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};

if (!hasOwn(IteratorPrototype$1, TO_STRING_TAG$1)) defineIteratorPrototypeAccessor(TO_STRING_TAG$1, ITERATOR);

if (FORCED$1 || !hasOwn(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$$3({ global: true, constructor: true, forced: FORCED$1 }, {
  Iterator: IteratorConstructor
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/ecma262/#sec-getiteratordirect
var getIteratorDirect$1 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var defineBuiltIn$1 = defineBuiltIn$5;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$1(target, key, src[key], options);
  return target;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var call$7 = functionCall;
var anObject$4 = anObject$c;
var getMethod$2 = getMethod$4;

var iteratorClose$4 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$4(iterator);
  try {
    innerResult = getMethod$2(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$7(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$4(innerResult);
  return value;
};

var iteratorClose$3 = iteratorClose$4;

var iteratorCloseAll$1 = function (iters, kind, value) {
  for (var i = iters.length - 1; i >= 0; i--) {
    if (iters[i] === undefined) continue;
    try {
      value = iteratorClose$3(iters[i].iterator, kind, value);
    } catch (error) {
      kind = 'throw';
      value = error;
    }
  }
  if (kind === 'throw') throw value;
  return value;
};

var call$6 = functionCall;
var create$1 = objectCreate;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIns = defineBuiltIns$1;
var wellKnownSymbol$2 = wellKnownSymbol$8;
var InternalStateModule = internalState;
var getMethod$1 = getMethod$4;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var createIterResultObject = createIterResultObject$1;
var iteratorClose$2 = iteratorClose$4;
var iteratorCloseAll = iteratorCloseAll$1;

var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var NORMAL = 'normal';
var THROW = 'throw';
var setInternalState = InternalStateModule.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns(create$1(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod$1(iterator, 'return');
        return returnMethod ? call$6(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$2(state.inner.iterator, NORMAL);
      } catch (error) {
        return iteratorClose$2(iterator, THROW, error);
      }
      if (state.openIters) try {
        iteratorCloseAll(state.openIters, NORMAL);
      } catch (error) {
        return iteratorClose$2(iterator, THROW, error);
      }
      if (iterator) iteratorClose$2(iterator, NORMAL);
      return createIterResultObject(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty$1(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');

var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};

var anObject$3 = anObject$c;
var iteratorClose$1 = iteratorClose$4;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$3(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, 'throw', error);
  }
};

// Should throw an error on invalid iterator
// https://issues.chromium.org/issues/336839115
var iteratorHelperThrowsOnInvalidIterator$1 = function (methodName, argument) {
  // eslint-disable-next-line es/no-iterator -- required for testing
  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
  if (method) try {
    method.call({ next: null }, argument).next();
  } catch (error) {
    return true;
  }
};

var globalThis$5 = globalThis_1;

// https://github.com/tc39/ecma262/pull/3467
var iteratorHelperWithoutClosingOnEarlyError$1 = function (METHOD_NAME, ExpectedError) {
  var Iterator = globalThis$5.Iterator;
  var IteratorPrototype = Iterator && Iterator.prototype;
  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];

  var CLOSED = false;

  if (method) try {
    method.call({
      next: function () { return { done: true }; },
      'return': function () { CLOSED = true; }
    }, -1);
  } catch (error) {
    // https://bugs.webkit.org/show_bug.cgi?id=291195
    if (!(error instanceof ExpectedError)) CLOSED = false;
  }

  if (!CLOSED) return method;
};

var $$2 = _export;
var call$5 = functionCall;
var aCallable = aCallable$2;
var anObject$2 = anObject$c;
var getIteratorDirect = getIteratorDirect$1;
var createIteratorProxy = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var iteratorClose = iteratorClose$4;
var iteratorHelperThrowsOnInvalidIterator = iteratorHelperThrowsOnInvalidIterator$1;
var iteratorHelperWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$1;

var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('filter', function () { /* empty */ });
var filterWithoutClosingOnEarlyError = !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR
  && iteratorHelperWithoutClosingOnEarlyError('filter', TypeError);

var FORCED = FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject$2(call$5(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
$$2({ target: 'Iterator', proto: true, real: true, forced: FORCED }, {
  filter: function filter(predicate) {
    anObject$2(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }

    if (filterWithoutClosingOnEarlyError) return call$5(filterWithoutClosingOnEarlyError, this, predicate);

    return new IteratorProxy(getIteratorDirect(this), {
      predicate: predicate
    });
  }
});

const generateKalturaPaletteFromTokens = tokens => {
  const primary = getPrimaryFromTokens(tokens.brandColor);
  return {
    primary: {
      dark: primary.dark,
      main: primary.main,
      light: primary.light,
      contrastText: primary.contrastText
    },
    secondary: {
      dark: primary.dark,
      main: primary.main,
      light: primary.light,
      contrastText: primary.contrastText
    },
    tone1: getColorFromTokens(tokens, EThemeColorType.Tone1),
    tone2: getColorFromTokens(tokens, EThemeColorType.Tone2),
    tone3: getColorFromTokens(tokens, EThemeColorType.Tone3),
    tone4: getColorFromTokens(tokens, EThemeColorType.Tone4),
    tone5: getColorFromTokens(tokens, EThemeColorType.Tone5),
    tone6: getColorFromTokens(tokens, EThemeColorType.Tone6),
    tone7: getColorFromTokens(tokens, EThemeColorType.Tone7),
    tone8: getColorFromTokens(tokens, EThemeColorType.Tone8),
    surfaces: {
      background: getColorFromTokens(tokens, EThemeColorType.SurfaceBackground),
      paper: getColorFromTokens(tokens, EThemeColorType.SurfacePaper),
      elevated: getColorFromTokens(tokens, EThemeColorType.SurfaceElevated),
      protection: getSurfacesProtection(tokens)
    }
  };
};

const generateKalturaTypographyFromTokens = tokens => {
  return {
    fontFamily: tokens.fontFamily,
    webFontUrl: tokens.webFontUrl,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    lineHeight: 'auto',
    color: defaultKalturaLightTones.tone1,
    heading1: {
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.0417,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '2rem'
    },
    heading2: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.0625,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '1rem'
    },
    heading3: {
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.084,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading4: {
      fontWeight: 700,
      fontSize: "1.25rem",
      lineHeight: 1.1,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading5: {
      fontWeight: 700,
      fontSize: "1.15rem",
      lineHeight: 1.11,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '0.25rem'
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.3125,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    body1Highlight: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: 1.3125,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.286,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    body2Highlight: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: 1.286,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    buttonLabel1: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    buttonLabel2: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    formLabel: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "16px",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    formError: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: "18px",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    }
  };
};

const generateEditorThemeFromTokensV2 = tokens => {
  const kalturaPaletteFromTokens = generateKalturaPaletteFromTokens(tokens);
  return {
    breakpoints: defaultKalturaBreakpoint,
    elevations: defaultKalturaElevations,
    palette: deepmerge$1(generateKalturaPalette(tokens.mode), kalturaPaletteFromTokens),
    shape: deepmerge$1(defaultKalturaShape, Object.assign(Object.assign({}, defaultKalturaShape), {
      roundness1: ERoundnessToNumberMapping[tokens.roundness]
    })),
    typography: deepmerge$1(generateKalturaTypography(), generateKalturaTypographyFromTokens(tokens)),
    mode: tokens.mode
  };
};

function addFontUrl(tokens) {
  var _a, _b;
  if ((_b = (_a = tokens.typography) === null || _a === void 0 ? void 0 : _a.webFontUrl) === null || _b === void 0 ? void 0 : _b.length) {
    try {
      const fontUrl = tokens.typography.webFontUrl;
      // check if the link was already added
      const links = document.getElementsByTagName('link'); // get all document links as HTMLCollection
      const previousLinks = Array.from(links).filter(tag => tag.title === 'kaltura-ds-custom-font' && tag.href === fontUrl);
      // if the link was not added yet - add it to the document header
      if (previousLinks.length === 0) {
        const link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.title = 'kaltura-ds-custom-font';
        link.href = fontUrl;
        document.head.appendChild(link);
      }
    } catch (e) {
      console.error(`Error loading custom font: ${e.message}`);
    }
  }
}
function createKalturaThemeFromTokens(tokensOrMode) {
  let tokens;
  if (typeof tokensOrMode === 'object') {
    if (isThemeEditorTokensV2(tokensOrMode)) {
      tokens = Object.assign({}, tokensOrMode);
    } else {
      //version not supported
      return null;
    }
  } else {
    tokens = Object.assign(Object.assign({}, defaultThemeEditorTokens), {
      mode: tokensOrMode
    });
  }
  return generateEditorThemeFromTokensV2(tokens);
}
const createVersionedKalturaTheme = overrides => {
  if (isThemeEditorTokens(overrides) && !isThemeEditorTokensV1(overrides)) {
    //if editor tokens overrides and not v1 - create calculated kaltura theme (version handling inside)
    //if version not supported then kalturaTheme is null - fallback to kaltura v2 with default mode
    const kalturaTheme = createKalturaThemeFromTokens(overrides);
    return kalturaTheme ? kalturaTheme : createKalturaThemeFromTokens('dark');
  } else {
    //if legacy overrides - create legacy kaltura theme
    const legacyOverrides = overrides;
    return createKalturaTheme({
      mode: legacyOverrides.mode || 'light',
      overrides: legacyOverrides
    });
  }
};

var $$1 = _export;
var globalThis$4 = globalThis_1;

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$$1({ global: true, forced: globalThis$4.globalThis !== globalThis$4 }, {
  globalThis: globalThis$4
});

var fails$4 = fails$l;
var globalThis$3 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis$3.RegExp;

var UNSUPPORTED_Y$1 = fails$4(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
UNSUPPORTED_Y$1 || fails$4(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$4(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET};

var fails$3 = fails$l;
var globalThis$2 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis$2.RegExp;

var regexpUnsupportedDotAll = fails$3(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$2 = fails$l;
var globalThis$1 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis$1.RegExp;

var regexpUnsupportedNcg = fails$2(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$4 = functionCall;
var uncurryThis$3 = functionUncurryThis;
var toString$2 = toString$7;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$3(''.charAt);
var indexOf = uncurryThis$3(''.indexOf);
var replace$1 = uncurryThis$3(''.replace);
var stringSlice$3 = uncurryThis$3(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$4(nativeExec, re1, 'a');
  call$4(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$4(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$4(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$1(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$4(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$4(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $ = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$3 = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$3.bind(apply$1) : function () {
  return call$3.apply(apply$1, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$2 = functionCall;
var defineBuiltIn = defineBuiltIn$5;
var regexpExec$1 = regexpExec$2;
var fails$1 = fails$l;
var wellKnownSymbol$1 = wellKnownSymbol$8;
var createNonEnumerableProperty = createNonEnumerableProperty$4;

var SPECIES = wellKnownSymbol$1('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$1(KEY);

  var DELEGATES_TO_SYMBOL = !fails$1(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$2(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$2(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$2 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$6;
var toString$1 = toString$7;
var requireObjectCoercible$1 = requireObjectCoercible$7;

var charAt$2 = uncurryThis$2(''.charAt);
var charCodeAt = uncurryThis$2(''.charCodeAt);
var stringSlice$2 = uncurryThis$2(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$1(requireObjectCoercible$1($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$1 = functionUncurryThis;
var toObject = toObject$4;

var floor = Math.floor;
var charAt = uncurryThis$1(''.charAt);
var replace = uncurryThis$1(''.replace);
var stringSlice$1 = uncurryThis$1(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$1 = functionCall;
var anObject$1 = anObject$c;
var isCallable$1 = isCallable$g;
var classof = classofRaw$1;
var regexpExec = regexpExec$2;

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$1(exec)) {
    var result = call$1(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call$1(regexpExec, R, S);
  throw new $TypeError('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call = functionCall;
var uncurryThis = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails = fails$l;
var anObject = anObject$c;
var isCallable = isCallable$g;
var isObject = isObject$7;
var toIntegerOrInfinity = toIntegerOrInfinity$6;
var toLength = toLength$3;
var toString = toString$7;
var requireObjectCoercible = requireObjectCoercible$7;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$4;
var getSubstitution = getSubstitution$1;
var getRegExpFlags = regexpGetFlags;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$8;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isObject(searchValue) ? getMethod(searchValue, REPLACE) : undefined;
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var flags = toString(getRegExpFlags(rx));
      var global = stringIndexOf(flags, 'g') !== -1;
      var fullUnicode;
      if (global) {
        fullUnicode = stringIndexOf(flags, 'u') !== -1;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

const augmentHighContrastTheme = (kalturaTheme, highContrast) => {
  // modify override colors and surface for high-contrast.
  const paletteOverrides = highContrast ? applyHighContrastKalturaPalette(kalturaTheme.mode, kalturaTheme.palette) : kalturaTheme.palette;
  return Object.assign(Object.assign({}, kalturaTheme), {
    palette: paletteOverrides
  });
};

// 1
try {
  if (globalThis && (!process || !process.env || process.env.STORYBOOK !== 'true')) {
    // https://github.com/facebook/regenerator/issues/378#issuecomment-765141043
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    globalThis.regeneratorRuntime = undefined;
  }
} catch (e) {
  // ignore
}
const ThemeProvider = ({
  cssPrefix,
  style,
  injectFirst,
  mode: _mode = 'light',
  overrides: _overrides = {},
  highContrast: _highContrast = false,
  children,
  className
}) => {
  const initialDataRef = useRef({
    cssPrefix,
    injectFirst
  });
  const cache = useMemo(() => {
    var _a;
    const windowAsAny = window || {};
    let normalizedKey = initialDataRef.current.cssPrefix.toLowerCase() === 'host' ? 'scoped-host' : initialDataRef.current.cssPrefix.toLowerCase();
    normalizedKey = `kltr-${normalizedKey.replace(/[^a-z-]/g, '-')}`;
    const options = {
      key: normalizedKey,
      prepend: initialDataRef.current.injectFirst
    };
    const nonce = ((_a = windowAsAny.kalturaGlobalConfig) === null || _a === void 0 ? void 0 : _a.stylesNonce) || '';
    if (nonce) {
      options.nonce = nonce;
    }
    return createCache(options);
  }, [initialDataRef]);
  const muiTheme = useMemo(() => {
    if (!_overrides || !Object.keys(_overrides).length) {
      //if no overrides - create default kaltura theme with mode
      return createMuiTheme(augmentHighContrastTheme(createKalturaTheme({
        mode: _mode
      }), _highContrast));
    } else {
      addFontUrl(_overrides);
      return createMuiTheme(augmentHighContrastTheme(createVersionedKalturaTheme(_overrides), _highContrast));
    }
  }, [_mode, _overrides, _highContrast]);
  return jsx(CacheProvider, {
    value: cache,
    children: jsx(ThemeProvider$1, {
      theme: muiTheme,
      children: jsx(ScopedCssBaseline, {
        style: style,
        className: className,
        children: jsx(ThemeProvider$2, {
          theme: muiTheme,
          children: children
        })
      })
    })
  });
};

const KalturaElevationToNumberMap = {
  'low': 0,
  'medium': 1,
  'high': 2
};
const VisibleFocusStyleBoxShadowStyle = {
  boxShadow: '0 0 0 2px #FFFFFF, 0 0 0 3px #0000FF'
};
const VisibleFocusStyle = Object.assign(Object.assign({}, VisibleFocusStyleBoxShadowStyle), {
  outline: 'thin solid #0000FF',
  outlineOffset: '2px',
  borderRadius: '4px'
});

// 7
try {
  if (globalThis && (!process || !process.env || process.env.STORYBOOK !== 'true')) {
    // https://github.com/facebook/regenerator/issues/378#issuecomment-765141043
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    globalThis.regeneratorRuntime = undefined;
  }
} catch (e) {
  // ignore
}
const HostThemeProvider = ({
  injectFirst,
  mode: _mode = 'light',
  overrides: _overrides = {},
  highContrast: _highContrast = false,
  renderCssBaseline,
  children
}) => {
  const initialDataRef = useRef({
    injectFirst
  });
  const cache = useMemo(() => {
    var _a;
    const windowAsAny = window || {};
    const options = {
      key: 'kltr-host',
      prepend: initialDataRef.current.injectFirst
    };
    const nonce = ((_a = windowAsAny.kalturaGlobalConfig) === null || _a === void 0 ? void 0 : _a.stylesNonce) || '';
    if (nonce) {
      options.nonce = nonce;
    }
    return createCache(options);
  }, [initialDataRef]);
  const muiTheme = React.useMemo(() => {
    if (!_overrides || !Object.keys(_overrides).length) {
      //if no overrides - create default kaltura theme with mode
      return createMuiTheme(augmentHighContrastTheme(createKalturaTheme({
        mode: _mode
      }), _highContrast));
    } else {
      addFontUrl(_overrides);
      return createMuiTheme(augmentHighContrastTheme(createVersionedKalturaTheme(_overrides), _highContrast));
    }
  }, [_mode, _overrides, _highContrast]);
  return jsx(CacheProvider, {
    value: cache,
    children: jsx(ThemeProvider$1, {
      theme: muiTheme,
      children: jsxs(ThemeProvider$2, {
        theme: muiTheme,
        children: [(renderCssBaseline !== null && renderCssBaseline !== void 0 ? renderCssBaseline : true) && jsx(CssBaseline, {}), children]
      })
    })
  });
};

export { CURRENT_EDITOR_VERSION, EColorScheme, ERoundness, ERoundnessToNumberMapping, EThemeColorType, EThemeEditorColorType, EThemeHightContrastColorType, HostThemeProvider, KalturaElevationToNumberMap, NumberToERoundnessMapping, ThemeProvider, VisibleFocusStyle, VisibleFocusStyleBoxShadowStyle, addFontUrl, augmentHighContrastTheme, colorTypeLightnessValuesMapping, createKalturaTheme, createKalturaThemeFromTokens, createMuiTheme, createVersionedKalturaTheme, defaultColor, defaultFontFamily, defaultThemeEditorTokens, getDefaultThemeEditorTokens, getThemeEditorColorSchemeTones, isThemeEditorTokens, isThemeEditorTokensV1, isThemeEditorTokensV2 };
